import React from 'react';
import { Loader2, Palette, AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

/** Auto-detect brand colour from a client's website (theme-color / favicon)
 * or set it manually. Detection is delegated to the parent (`onDetect`). */
export const BrandColorDialog = ({
  open, onOpenChange, tenantName, form, setForm,
  error, saving, detecting, onDetect, onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg bg-slate-50 border-slate-200 text-slate-900" data-testid="brand-color-dialog">
      <DialogHeader>
        <DialogTitle className="text-slate-900">Cor da Marca — {tenantName}</DialogTitle>
        <DialogDescription className="text-slate-500">
          Deteta automaticamente a partir do site do cliente (theme-color / favicon) ou defina manualmente.
        </DialogDescription>
      </DialogHeader>

      {error && (
        <Alert variant="destructive" className="bg-red-50 border-red-200">
          <AlertTriangle className="w-4 h-4 text-red-600" />
          <AlertDescription className="text-red-700">{error}</AlertDescription>
        </Alert>
      )}

      <div className="space-y-3">
        <div>
          <Label>URL do Site</Label>
          <div className="flex gap-2 mt-1">
            <Input
              value={form.website_url}
              onChange={(e) => setForm(prev => ({ ...prev, website_url: e.target.value }))}
              placeholder="https://empresa.com"
              className="bg-white border-slate-300 text-slate-900"
              data-testid="super-admin-website-url-input"
            />
            <Button
              variant="outline"
              onClick={onDetect}
              disabled={detecting || !form.website_url}
              className="border-slate-300 text-slate-600 hover:bg-slate-100 whitespace-nowrap"
              data-testid="super-admin-detect-color-btn"
            >
              {detecting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Palette className="w-4 h-4 mr-2" />}
              Detetar
            </Button>
          </div>
        </div>
        <div>
          <Label>Cor Principal</Label>
          <div className="flex gap-2 mt-1">
            <input
              type="color"
              value={form.primary_color}
              onChange={(e) => setForm(prev => ({ ...prev, primary_color: e.target.value }))}
              className="w-10 h-10 rounded border cursor-pointer"
            />
            <Input
              value={form.primary_color}
              onChange={(e) => setForm(prev => ({ ...prev, primary_color: e.target.value }))}
              className="bg-white border-slate-300 text-slate-900 w-32"
              data-testid="super-admin-primary-color-input"
            />
          </div>
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-300 text-slate-600 hover:bg-slate-100">
          Cancelar
        </Button>
        <Button
          onClick={onSubmit}
          disabled={saving}
          className="bg-indigo-700 hover:bg-amber-600 text-black"
          data-testid="save-brand-color-btn"
        >
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
          Guardar
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
